import styled from 'styled-components';
import { color, space, fontWeight, fontSize, fontStyle } from 'styled-system';
import { Typography } from 'antd';

const Text = styled(Typography.Text)`
  ${color} !important;
  ${space};
  ${fontWeight};
  ${fontSize};
  ${fontStyle};
`;

export default Text;
